export default "__VITE_ASSET__CgIev76m__"